import $ from 'dom7';

export class usadosFunciones {

    // Defino variable global
    get servicioGlobal () {
        // return 'http://localhost:8888'
        // return 'https://apiusados.cdms.com.ar'
        return 'https://apiperitaje.arias.cdms.com.ar'
    }

    get imagenesGlobal () {
      let upload_directory = this.servicioGlobal + '/uploads';
      return upload_directory
  }

    /*
    SECCION USADOSABM
    */

    // Carga lo datos de un vehiculo en la pantalla de edicion
    listarVehiculo($f7, vehiculoID){
      let userID = localStorage.getItem('idUser');
      console.log(userID);
      

      let url = this.servicioGlobal + '/datos-vehiculos/getAll/' + vehiculoID;
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let vehiculos = informacion.vehiculos;

            vehiculos.forEach(element => {
              $('#patente').val(element.patente);
              $('#anio').val(element.anio);
              $('#kilometros').val(element.kilometros);
              $('#total_gastos').val(element.total_gastos);
              $('#color').val(element.idcolor);
              $('#comentario').val(element.descripcion);
              $('#vendedor').val(element.idvendedor);
              $('#inspector').val(element.idinspector);
            });

          }else{
            $f7.dialog.alert('No existen datos del vehiculo para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    // Cargar listado de elementos a peritar
    listarElementosPericias ($f7, vehiculoID){
      $('#listadoCheck').empty();
      let consultaID = localStorage.getItem('consultaID');
      
      let url = this.servicioGlobal + '/datos-vehiculos/peritaje';
      if(vehiculoID){
          url = this.servicioGlobal + '/datos-vehiculos/peritaje/' + vehiculoID;
      }
      
      $f7.request({
        url: url,
        method: 'get',
        data: {'vehiculo': vehiculoID },
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          let select_estado = (consultaID > 0) ? ' disabled' : '';
          let input_estado = (consultaID > 0) ? ' readonly' : 'xxxxx';

          if(true){
            let tareas = informacion.tareas;
            let contenido = '';
            
            informacion.forEach(element => {

              let contenido_body = '';
              let total  = '';
              element.tareas.forEach(tarea => {
                let contenido_seleccion  = '';
                

                if(tarea.tipo == 'select'){
                  contenido_seleccion += '<select class="form-select" data-choices name="tarea_'+tarea.idchecklist+'" id="tarea_'+tarea.idchecklist+'" onchange="saveTarea('+vehiculoID+', '+tarea.idchecklist+', \''+tarea.tipo+'\', this.value)" '+select_estado+'> \n';
                  contenido_seleccion += '<option value="0">Seleccione Respuesta</option> \n';
                  tarea.respuestas.forEach(respuesta => {
                    contenido_seleccion += '<option value="'+respuesta.iditemchecklist+'" '+respuesta.valor+'>'+respuesta.texto+'</option> \n';
                  });
                  contenido_seleccion += '</select>';
                }

                if(tarea.tipo == 'input'){
                  contenido_seleccion += '<input type="text" name="tarea_'+tarea.idchecklist+'" id="tarea_'+tarea.idchecklist+'" value="'+tarea.respuestas[0].valor+'" onchange="saveTarea('+vehiculoID+', '+tarea.idchecklist+', \''+tarea.tipo+'\', this.value)" placeholder="" '+input_estado+'/>';
                }

                
            
                // contenido_body += '<tr> \n' +
                // '<td>'+tarea.texto+'</td> \n' +
                // '<td>'+contenido_seleccion+'</td> \n' +
                // '</tr> \n';

                contenido_body += '<p style="font-weight:bold">'+tarea.texto+'</p> \n';
                contenido_body += contenido_seleccion;
                contenido_body += '<div class="dropdown-divider"><hr></div> \n';

                total = '<tr> \n' +
                  '<td style="border-top:solid 1px black"><span style="font-weight:bold">TOTAL DE GASTOS</td> \n' +
                  '<td style="border-top:solid 1px black"><input type="text" id="'+element.idgrupo+'" name="'+element.idgrupo+'" value="'+element.total_grupo+'" onchange="saveTotalTarea('+vehiculoID+', '+element.idgrupo+', this.value)" style="text-align:right" '+input_estado+'></td> \n' +
                  '</tr> \n';

              });

              contenido += '<li class="accordion-item"><a class="item-content item-link" href="#"> \n' + 
                  '<div class="item-inner"> \n' + 
                    '<div class="item-title" style="color:#005580">'+element.grupo+'</div> \n' + 
                  '</div> \n' + 
                '</a> \n' + 
                '<div class="accordion-item-content"> \n' + 
                  '<div class="block"> \n' + 
                    contenido_body + total +
                  '</div> \n' + 
                '</div> \n' + 
              '</li>';
            });
            $('#listadoCheck').append(contenido);
          }else{
            $f7.dialog.alert('No existen vehiculos para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
      
    }



    // Carga el listado con todos lo vehiculos en la pantalla principal
    // +++++ Esta faltando que muestre los de usuario logueado
    // +++++ Esta faltando la paginacion del listado

    listarVehiculos ($f7, user){
      $('#listadoUsados').empty();
      let consultaID = localStorage.getItem('consultaID');
      
      let url = this.servicioGlobal + '/datos-vehiculos/getAll';
      if(user){
          url = this.servicioGlobal + '/datos-vehiculos/getAll/' + user;
      }

      if(consultaID){
          url = this.servicioGlobal + '/datos-vehiculos/getAll?user=' + consultaID;
      }
      
      $f7.request({
        url: url,
        method: 'get',
        data: {'vehiculo': user },
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let vehiculos = informacion.vehiculos;
            let contenido = '';
            vehiculos.forEach(element => {
              contenido += '<li> \n' +
                            '<a href="/abm/?id='+element.id+'&marca='+element.idmarca+'&modelo='+element.idmodelo+'&version='+element.idversion+'+&idestado='+element.idestado+'&vendedor='+element.idvendedor+'&inspector='+element.idinspector+'&color='+element.color+'&alta='+element.alta+'" class="item-link item-content"> \n' +
                              '<div class="item-media"><img src="https://vw.arias.cdms.com.ar/inicio/images/auto.jpg" \n' +
                                  'width="80" /></div> \n' +
                              '<div class="item-inner"> \n' +
                                '<div class="item-title-row"> \n' +
                                  '<div class="item-title">'+element.marca+'</div> \n' +
                                  '<div class="item-after"><span style="font-weight:bold;color:#000">'+element.anio+'</span></div> \n' +
                                '</div> \n' +
                                '<div class="item-subtitle">'+element.modelo+'</div> \n' +
                                '<div class="item-text">'+element.patente+'</div> \n' +
                              '</div> \n' +
                            '</a> \n' +
                          '</li>';
            });
            $('#listadoUsados').append(contenido);
          }else{
            $f7.dialog.alert('No existen vehiculos para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    // Gurdar / Actualizar datos principales
    saveVehiculos($f7, form){
      let formData = $f7.form.convertToData('#'+form);
      let url = this.servicioGlobal + '/datos-vehiculos/saveVehiculo';

      $f7.request({
        url: url,
        method: 'post',
        // dataType: 'json',
        data: formData,
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);
          if(informacion.Error == 0){
            $f7.dialog.alert(informacion.Mensaje);
            $('#btn-imagen-color').css('color', '#00b33c');
            $('#btn-href-url').attr("href", '/usadosimagenes/?id_vehiculo='+informacion.Vehiculo_id); // debo agregar el numero de vehiculo

            $('#btn-imagen-color').css('color', '#00b33c');
            $('#btn-href-url-peritaje').attr("href", '/usadosperitajes/?id_vehiculo='+informacion.Vehiculo_id);
          }else{
            $f7.dialog.alert(informacion.Mensaje);
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });

    }

    // Funciones para carga de desplegables
    getMarcas($f7, marcaID) {
      let url = this.servicioGlobal + '/datos-vehiculos/marcas';
      $('#get-marcas').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let marcas = informacion.marcas;
            let contenido = '<option value="0">Seleccionar ...</option>';
            marcas.forEach(element => {
              let selected = (marcaID == element.idmarca && marcaID != 0) ? ' selected' : '';
              if(marcaID == element.idmarca && marcaID != 0){
                $('#get-marcas-title').html(element.marca);
              }
              contenido += '<option value="'+element.idmarca+'"'+selected+'>'+element.marca+'</option>';
            });
            $('#get-marcas').append(contenido);
          }else{
            console.log('No existen marcas para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getModelos($f7, marcaID, modeloID) {
      let url = this.servicioGlobal + '/datos-vehiculos/modelos/' + marcaID;
      $('#get-modelos').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let modelos = informacion.modelos;
            let contenido = '<option value="0">Seleccionar ...</option>';
            modelos.forEach(element => {
              let selected = (modeloID == element.idmodelo && modeloID != 0) ? ' selected' : '';
              if(modeloID == element.idmodelo && modeloID != 0){
                $('#get-modelos-title').html(element.descripcion);
              }
              contenido += '<option value="'+element.idmodelo+'"'+selected+'>'+element.descripcion+' ('+element.anio+')</option>';
            });
            $('#get-modelos').append(contenido);
          }else{
            console.log('No existen modelos para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getVersiones($f7, modeloID, versionID) {
      let url = this.servicioGlobal + '/datos-vehiculos/versiones/' + modeloID;
      $('#get-versiones').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let modelos = informacion.modelos;
            let contenido = '<option value="0">Seleccionar ...</option>';
            modelos.forEach(element => {
              let selected = (versionID == element.idversion && versionID != 0) ? ' selected' : '';
              if(versionID == element.idversion && versionID != 0){
                $('#get-versiones-title').html(element.descripcion);
              }
              contenido += '<option value="'+element.idversion+'"'+selected+'>'+element.descripcion+'</option>';
            });
            $('#get-versiones').append(contenido);
          }else{
            console.log('No existen veriones para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getUsuarioByPerfil($f7, perfilID, selector, id=0) {
      
      let url = this.servicioGlobal + '/usuarios/getAllUsersByPerfil/' + perfilID;
      $('#' + selector).empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let usuarios = informacion.data;
            let contenido = '<option value="0">Seleccionar ...</option>';
            usuarios.forEach(element => {
              let selected = (id == element.id && id != 0) ? ' selected' : '';
              if(id == element.id && id != 0){
                $('#'+selector+'-title').html(element.nombre + ' '+ element.apellido);
              }
              contenido += '<option value="'+element.id+'"'+selected+'>'+element.nombre + ' '+ element.apellido +'</option>';
            });
            $('#' + selector).append(contenido);
          }else{
            console.log('No existen datos para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getEstados($f7, estadosID) {
      let url = this.servicioGlobal + '/datos-vehiculos/getAllEstados';
      $('#get-estados').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let estados = informacion.estados;
            let contenido = '<option value="0">Seleccionar ...</option>';
            estados.forEach(element => {
              let selected = (estadosID == element.idestado && estadosID != 0) ? ' selected' : '';
              if(estadosID == element.idestado && estadosID != 0){
                $('#get-estados-title').html(element.descripcion);
              }
              contenido += '<option value="'+element.idestado+'"'+selected+'>'+element.descripcion+'</option>';
            });
            $('#get-estados').append(contenido);
          }else{
            console.log('No existen marcas para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getVendedores($f7, vendedorID) {
      let url = this.servicioGlobal + '/dms/vendedores';
      $('#get-vendedores').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let result = JSON.parse(data);

          if(result.cantidad > 0){
            let vendedores = result.vendedores;
            let contenido = '<option value="0">Seleccionar ...</option>';
            vendedores.forEach(element => {
              let selected = (vendedorID == element.idvendedor && vendedorID != 0) ? ' selected' : '';
              if(vendedorID == element.idvendedor && vendedorID != 0){
                $('#get-vendedores-title').html(element.vendedor);
              }
              contenido += '<option value="'+element.idvendedor+'"'+selected+'>'+element.vendedor+'</option>';
            });
            $('#get-vendedores').append(contenido);
          }else{
            console.log('No existen vendedores para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getInspectores($f7, inspectorID) {
      let url = this.servicioGlobal + '/dms/inspectores';
      $('#get-inspectores').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let result = JSON.parse(data);

          if(result.cantidad > 0){
            let inspectores = result.inspectores;
            let contenido = '<option value="0">Seleccionar ...</option>';
            inspectores.forEach(element => {
              let selected = (inspectorID == element.idinspector && inspectorID != 0) ? ' selected' : '';
              if(inspectorID == element.idinspector && inspectorID != 0){
                $('#get-inspectores-title').html(element.inspector);
              }
              contenido += '<option value="'+element.idinspector+'"'+selected+'>'+element.inspector+'</option>';
            });
            $('#get-inspectores').append(contenido);
          }else{
            console.log('No existen inspectores para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getColores($f7, colorID) {
      let url = this.servicioGlobal + '/dms/colores';
      $('#get-colores').empty();
      console.log(colorID);
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let result = JSON.parse(data);

          if(result.cantidad > 0){
            let colores = result.colores;
            let contenido = '<option value="0">Seleccionar ...</option>';
            colores.forEach(element => {
              let selected = (colorID == element.idcolor && colorID != 0) ? ' selected' : '';
              if(colorID == element.idcolor && colorID != 0){
                $('#get-colores-title').html(element.color);
              }
              contenido += '<option value="'+element.idcolor+'"'+selected+'>'+element.color+'</option>';
            });
            $('#get-colores').append(contenido);
          }else{
            console.log('No existen colores para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    /*
    SECCION USADOSIMAGENES
    */

    // Mostrar listado con las imagenes correspondientes a un peritaje
    listarImagenes($f7, vehiculoID){
      let t = new Date().getTime();
      let consultaID = localStorage.getItem('consultaID');

      $("#get-imagenes").empty();
      let url = this.servicioGlobal + '/datos-vehiculos/getAllImagenes/' + vehiculoID;
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let imagenes = informacion.imagenes;
            let contenido = '';
            let imagen_estado = (consultaID > 0) ? ';display:none' : '';
            imagenes.forEach(element => {
              contenido += '<div class="card demo-facebook-card" id="imagen-'+element.idimagen+'"> \n' +
              '<div class="card-content card-content-padding"> \n' +
                '<img src="'+element.pathimagen + '?t=' + t +'" width="100%" /> \n' +
                '<p class="likes">'+element.comentario+'</p> \n' +
              '</div> \n' +
              '<div class="card-footer"><a href="/eliminarImagen/'+vehiculoID+'/'+element.idimagen+'/" class="link delete-imagen" style="color:red'+imagen_estado+'" data-imagen="'+element.idimagen+'">Eliminar</a></div> \n' +
            '</div>';
            });
            $('#get-imagenes').append(contenido);

          }else{
            console.log('No existen imagenes para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    addImageneSubida($f7, imagenName, imagenID, vehiculoID){
    let t = new Date().getTime();
    let url = this.servicioGlobal + '/datos-vehiculos/getRuta';

    $f7.request({
      url: url,
      method: 'get',
      success: function (data, status, xhr) {
        let informacion = JSON.parse(data);

        if(informacion.Ruta){
          let contenido = '';
          contenido += '<div class="card demo-facebook-card" id="imagen-'+imagenID+'"> \n' +
            '<div class="card-content card-content-padding"> \n' +
            '<img src="'+ informacion.Ruta+imagenName + '?t=' + t +'" width="100%" /> \n' +
            '<p class="likes"></p> \n' +
            '</div> \n' +
            '<div class="card-footer"><a href="/eliminarImagen/'+vehiculoID+'/'+imagenID+'/" class="link delete-imagen" style="color:red" data-imagen="'+imagenID+'">Eliminar</a></div> \n' +
          '</div>';
      
          $('#get-imagenes').append(contenido);
          $('#save-imagen').hide();
        }else{
          console.log('La ruta para imagenes no se encuentra definida');
        }

      },
      statusCode: {
        404: function (xhr) {
          alert('Servicio no encontrado');
        }
      }
    });
    }

    eliminarImagen(app, imagenID, router){
      let url = this.servicioGlobal + '/datos-vehiculos/delImagen/'+imagenID;
      app.request.get(url)
      .then(function (res) {
        // app.views.main.router.back(); // funciona
        // app.views.main.router.refreshPage()
        $('#imagen-' + imagenID).hide();
        console.log('#imagen-' + imagenID);
        
      })
      .catch(function (err) {
        console.log(err.xhr)
        console.log(err.status)
        console.log(err.message)
      })
    }

    editarImagen(imagenID){
      alert('Editar: ' + imagenID);
    }

    saveImagen(){
      console.log('desde calse');
      return false;
    }

    saveTarea($f7, idVehiculo,idTarea,tipo,valor){
      let url = this.servicioGlobal + '/datos-vehiculos/saveValorTarea';
      let userID = $('#id_usuario').val();
      $f7.request({
        url: url,
        method: 'post',
        // dataType: 'json',
        data: {idVehiculo: idVehiculo, idTarea: idTarea, tipo: tipo, valor: valor, idUsuario: userID },
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);
          if(informacion.Error == 0){
            console.log(informacion);
          }else{
            console.log('Error al actualizar datos de peritaje');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    saveTotalTarea($f7,idVehiculo,idGrupoTarea,valor){

      let url = this.servicioGlobal + '/datos-vehiculos/saveTotalTarea';
      let userID = $('#id_usuario').val();

      $f7.request({
        url: url,
        method: 'post',
        // dataType: 'json',
        data: {idVehiculo: idVehiculo, idGrupo: idGrupoTarea, valor: valor, idUsuario: userID },
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);
          if(informacion.Error == 0){
            console.log(informacion);
          }else{
            console.log('Error al actualizar datos de peritaje');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    
      return false;
    }
}